import React, {Fragment} from 'react';
import {
	Container,
	DatePickerContainer,
	DatePickerContent,
	DatePickerWrapper,
	Divider,
} from './styles';
import {DatePickerHeader} from './components/DatePickerHeader';
import {Calendar} from './components/Calendar';
import {DatePickerLayoutProps} from './DatePicker.types';
import {LabelSelectedDates} from './components/LabelSelectedDates';

const DatePickerLayout: React.FC<DatePickerLayoutProps> = ({
	visible,
	showNextMonth,
	isMobileWidthDimension,
	handlePrevMonth,
	handleNextMonth,
	monthState,
	yearState,
	disabledButtonPrevMonth,
	disabledButtonNextMonth,
	lang,
	monthFirstCalendar,
	yearFirstCalendar,
	monthSecondCalendar,
	yearSecondCalendar,
	typeTextWeekDay,
	renderCalendarCurrentMonth,
	renderCalendarNextMonth,
	footerContent,
	firstDaySelected,
	secondDaySelected,
	showLabelSelectedDates,
	...restDatePicker
}) => {
	const showNextMonthInDesktop = showNextMonth && !isMobileWidthDimension;

	return (
		<Container visible={visible} {...restDatePicker}>
			<DatePickerWrapper>
				<DatePickerContainer>
					{showLabelSelectedDates ? (
						<LabelSelectedDates
							firstDaySelected={firstDaySelected}
							secondDaySelected={secondDaySelected}
						/>
					) : null}
					<DatePickerHeader
						showNextMonth={showNextMonth && !isMobileWidthDimension}
						onPrevMonth={handlePrevMonth}
						onNextMonth={handleNextMonth}
						month={monthState}
						lang={lang}
						year={yearState}
						disableButtonPrevMonth={disabledButtonPrevMonth}
						disableButtonNextMonth={disabledButtonNextMonth}
					/>
					<DatePickerContent>
						<Calendar
							month={monthFirstCalendar}
							year={yearFirstCalendar}
							lang={lang}
							showNextMonth={showNextMonth && !isMobileWidthDimension}
							typeTextWeekDay={typeTextWeekDay}>
							{renderCalendarCurrentMonth(yearState, monthState)}
						</Calendar>
						{showNextMonthInDesktop ? (
							<Fragment>
								<Divider />
								<Calendar
									month={monthSecondCalendar}
									year={yearSecondCalendar}
									lang={lang}
									showNextMonth={showNextMonth}
									typeTextWeekDay={typeTextWeekDay}>
									{renderCalendarNextMonth(
										yearSecondCalendar,
										monthSecondCalendar + 1,
									)}
								</Calendar>
							</Fragment>
						) : null}
					</DatePickerContent>
				</DatePickerContainer>
				{footerContent}
			</DatePickerWrapper>
		</Container>
	);
};

export {DatePickerLayout};
